import { z } from 'zod';

//* Define your environment variables schema here, so you get type safety throughout your app
export const EnvSchema = z.object({
  API_BASE_URL: z.string().url(),
  ASSETS_FOLDER: z.string().url(),
  TENANT: z.string(),
  GAMEZONE_URL: z.string().url(),
  ENABLED_LANGUAGES: z.string(),
  GLITCH_TIP_DSN: z.string().url().optional(),

  FEATURE_NON_LOGIN_ENABLED: z.string().optional(),
  GTM_TOKEN: z.string().optional(),
});
